<template>
<div>
  <p-radio
    @input="emitEvent(company)"
    v-model="companyTerms"
    v-for="(company, index) in currentTerms"
    :key="index"
    :label="company"
  >
    {{ company.toUpperCase() }}
  </p-radio>
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'CompanyTermsRadios',

  props: {
    model: {
      required: true
    }
  },

  data: () => ({
    companyTerms: ''
  }),

  watch: {
    model () {
      this.$nextTick(() => {
        this.companyTerms = this.model.companyTerms
      })
    }
  },

  computed: {
    ...mapGetters('events', ['event']),
    ...mapGetters('project', ['currentTerms', 'project'])
  },

  methods: {
    ...mapActions('project', ['fetchOne']),

    emitEvent (company) {
      this.$emit('input', company)
    }
  },

  mounted () {
    if (!this.project.hasOwnProperty('_id')) {
      this.fetchOne('config')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Trg/CompanyTermsRadios.vue